import { useApiData } from './useApiData'

export type ConsentResponse = {
  title: string
  content: string
  okButtonText: string
  cancelButtonText: string
}

export const useConsentData = (skip?: boolean) => {
  const { data, loading, refresh, error, errorStatus } = useApiData<ConsentResponse>(
    {
      url: '/api/content/CompanyConsentDialog',
      method: 'get'
    },
    {
      umbracoCall: true,
      skip
    }
  )

  return { data, loading, refresh, error, errorStatus }
}
